export default __webpack_public_path__ + "static/media/TheToysParty_01.0987c8cb.png";